import React from 'react';
import { Link } from 'react-router-dom';
import NavigationBar from 'components/ui/NavigationBar'; // adjust if your nav lives elsewhere
import Icon from 'components/AppIcon';

const ComingSoon = ({ label, description }) => {
  return (
    <div className="min-h-screen bg-background">
      <NavigationBar />
      <main className="flex min-h-screen items-center justify-center px-4 pt-24 pb-12">
        <div className="w-full max-w-lg rounded-xl border border-border bg-card p-12 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-accent/10">
            <Icon name="Hammer" size={24} className="text-accent" />
          </div>
          <h1 className="mb-1 text-2xl font-semibold text-foreground">{label}</h1>
          <p className="mb-6 text-sm text-muted-foreground">
            {description || 'This page is being built. Check back soon.'}
          </p>
          <Link
            to="/home-landing-page"
            className="inline-flex items-center rounded-full bg-black px-5 py-2 text-sm font-medium text-white hover:bg-black/90"
          >
            Back to Home
          </Link>
        </div>
      </main>
    </div>
  );
};

export default ComingSoon;